import { parseAsStringLiteral } from 'nuqs';

export const GM_DRAWER_QUERY_KEY = 'gmDrawer';

const drawerViews = ['half-missions', 'half-rewards', 'missions', 'rewards'] as const;

export const gmDrawerQueryParser = parseAsStringLiteral(drawerViews).withOptions({
  history: 'replace',
  shallow: true,
});

export type GmDrawerView = typeof drawerViews[number];
export type GmMobileBarTab = 'missions' | 'rewards';

export const getDrawerSnapPointIndex = (view: GmDrawerView | null) => {
  if (view === null) {
    return 0;
  }

  return view.startsWith('half-') ? 1 : 2;
};

export const getDrawerTab = (view: GmDrawerView | null): GmMobileBarTab => (
  view?.endsWith('rewards') ? 'rewards' : 'missions'
);

export const getDrawerView = (snapPointIndex: number, tab: GmMobileBarTab): GmDrawerView | null => {
  if (snapPointIndex === 0) {
    return null;
  }

  return snapPointIndex === 1 ? `half-${tab}` : tab;
};
